import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';

const ProjectCtaSection = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  return (
    <section className="section section-light" style={{ position: 'relative', overflow: 'hidden', padding: '7rem 0' }}>
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div className="cta-card fade-in" style={{
          background: 'linear-gradient(135deg, var(--assco-orange), #ff8c3f)',
          borderRadius: 'var(--radius-2xl)',
          padding: '5rem',
          color: 'white',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 25px 50px rgba(255, 107, 0, 0.2)'
        }}>
          {/* Background pattern */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M0 0h40v40H0V0zm40 40h40v40H40V40zm0-40h2l-2 2V0zm0 4l4-4h2l-6 6V4zm0 4l8-8h2L2 38v-2l38-38zm0 4L42 0h2L2 42v-2l38-38zm0 4L46 0h2L2 46v-2l38-38zm0 4L50 0h2L2 50v-2l38-38zm0 4L54 0h2L2 54v-2l38-38zm0 4L58 0h2L2 58v-2l38-38zm0 4L62 0h2L2 62v-2l38-38zm0 4L66 0h2L2 66v-2l38-38zm0 4L70 0h2L2 70v-2l38-38zm0 4L74 0h2L2 74v-2l38-38zm0 4L78 0h2L2 78v-2l38-38z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            opacity: 0.2
          }}></div>
          
          {/* Decorative elements */}
          <div style={{
            position: 'absolute',
            top: '-70px',
            right: '-70px',
            width: '250px',
            height: '250px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0) 70%)'
          }}></div>
          
          <div style={{
            position: 'absolute',
            bottom: '-50px',
            left: '-50px',
            width: '200px',
            height: '200px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 70%)'
          }}></div>
          
          {/* Floating decorative elements */}
          <div style={{
            position: 'absolute',
            top: '15%',
            right: '12%',
            width: '50px',
            height: '50px',
            borderRadius: '12px',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            transform: 'rotate(15deg)',
            animation: 'float 7s ease-in-out infinite'
          }}></div>
          
          <div style={{
            position: 'absolute',
            bottom: '20%',
            left: '10%',
            width: '30px',
            height: '30px',
            borderRadius: '8px',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            transform: 'rotate(-10deg)',
            animation: 'float 5s ease-in-out infinite 1s'
          }}></div>
          
          <div style={{
            position: 'absolute',
            top: '60%',
            right: '25%',
            width: '20px',
            height: '20px',
            borderRadius: '50%',
            backgroundColor: 'rgba(255, 255, 255, 0.15)',
            animation: 'float 6s ease-in-out infinite 0.5s'
          }}></div>
          
          <div className="grid" style={{ 
            display: 'grid',
            gridTemplateColumns: 'repeat(12, 1fr)', 
            gap: '3rem',
            alignItems: 'center',
            position: 'relative',
            zIndex: 2
          }}>
            <div className="col-span-8 md-col-span-12">
              <span style={{
                display: 'inline-block',
                padding: '0.75rem 1.5rem',
                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                borderRadius: 'var(--radius-full)',
                marginBottom: '1.5rem',
                fontWeight: '600',
                fontSize: '0.95rem'
              }}>
                {language === 'fr' ? 'NOUVEAU PROJET' : 
                 language === 'ar' ? 'مشروع جديد' : 
                 'NEW PROJECT'}
              </span>
              
              <h2 style={{ 
                fontSize: '3rem',
                marginBottom: '1.75rem',
                color: 'white',
                fontWeight: '700',
                lineHeight: '1.2'
              }}>
                {language === 'fr' 
                  ? 'Prêt à démarrer votre prochain projet d\'instrumentation ?' 
                  : language === 'ar'
                  ? 'هل أنت مستعد لبدء مشروع القياس التالي الخاص بك؟'
                  : 'Ready to start your next instrumentation project?'}
              </h2>
              
              <p style={{ 
                fontSize: '1.25rem',
                marginBottom: '2.5rem',
                color: 'rgba(255, 255, 255, 0.9)',
                lineHeight: '1.8',
                maxWidth: '700px',
                fontWeight: '500'
              }}>
                {language === 'fr' 
                  ? 'Contactez-nous dès aujourd\'hui pour discuter de vos besoins en matière d\'instrumentation Pétrole, Gaz et Industrie. Notre équipe d\'experts vous guidera tout au long du processus, de la conception à la mise en œuvre.' 
                  : language === 'ar'
                  ? 'اتصل بنا اليوم لمناقشة احتياجات القياس البتروكيماوية الخاصة بك. سيرشدك فريق الخبراء لدينا خلال العملية بأكملها، من التصميم إلى التنفيذ.'
                  : 'Contact us today to discuss your petrochemical instrumentation needs. Our team of experts will guide you through the entire process, from design to implementation.'}
              </p>
              
              <div style={{
                display: 'flex',
                gap: '1.25rem',
                flexWrap: 'wrap'
              }}>
                <Link 
                  to="/contact" 
                  className="btn btn-white"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                    backgroundColor: 'white',
                    color: 'var(--assco-orange)',
                    padding: '1rem 2.5rem',
                    borderRadius: 'var(--radius-xl)',
                    fontWeight: '600',
                    fontSize: '1.1rem',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1)',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 15px 30px rgba(0, 0, 0, 0.15)';
                    
                    // Move the arrow icon
                    const svg = e.currentTarget.querySelector('svg');
                    if (svg) {
                      svg.style.transform = 'translateX(5px)';
                    }
                    
                    // Create ripple effect
                    const ripple = document.createElement('span');
                    const rect = e.currentTarget.getBoundingClientRect();
                    const x = e.clientX - rect.left;
                    const y = e.clientY - rect.top;
                    
                    ripple.style.position = 'absolute';
                    ripple.style.width = '100px';
                    ripple.style.height = '100px';
                    ripple.style.borderRadius = '50%';
                    ripple.style.backgroundColor = 'rgba(255, 107, 0, 0.1)';
                    ripple.style.top = `${y - 50}px`;
                    ripple.style.left = `${x - 50}px`;
                    ripple.style.transform = 'scale(0)';
                    ripple.style.animation = 'ripple 0.6s linear';
                    
                    e.currentTarget.appendChild(ripple);
                    
                    setTimeout(() => {
                      e.currentTarget.removeChild(ripple);
                    }, 600);
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 10px 20px rgba(0, 0, 0, 0.1)';
                    
                    // Reset arrow icon
                    const svg = e.currentTarget.querySelector('svg');
                    if (svg) {
                      svg.style.transform = 'translateX(0)';
                    }
                  }}
                >
                  {language === 'fr' ? 'Discuter de votre projet' : 
                   language === 'ar' ? 'مناقشة مشروعك' : 
                   'Discuss your project'}
                  <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '20px', height: '20px', transition: 'transform 0.3s ease' }} viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </Link>
                
                <Link 
                  to="/services" 
                  className="btn btn-outline"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    backgroundColor: 'transparent',
                    color: 'white',
                    padding: '0.75rem 2rem',
                    borderRadius: 'var(--radius-full)',
                    border: '2px solid white',
                    fontWeight: '600',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  {language === 'fr' ? 'Voir nos services' : 
                   language === 'ar' ? 'عرض خدماتنا' : 
                   'View our services'}
                </Link>
              </div>
            </div>
            
            <div className="col-span-4 md-col-span-12 md-hidden" style={{ position: 'relative' }}>
              {/* Project graphic */}
              <div style={{
                position: 'relative',
                width: '100%',
                height: '300px'
              }}>
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '200px',
                  height: '200px',
                  borderRadius: '50%',
                  border: '15px solid rgba(255, 255, 255, 0.2)',
                  animation: 'pulse 3s infinite'
                }}></div>
                
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '120px',
                  height: '120px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255, 255, 255, 0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '60px', height: '60px', color: 'white' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes pulse {
          0% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 0.2;
          }
          50% {
            transform: translate(-50%, -50%) scale(1.1);
            opacity: 0.3;
          }
          100% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 0.2;
          }
        }
      `}</style>
    </section>
  );
};

export default ProjectCtaSection;